import React, {useEffect, useRef} from 'react';
import { init } from 'ityped'
import "./introduction.scss"

export default function Introduction() {

  const textRef = useRef();

  useEffect(()=>{
    init(textRef.current, { showCursor: true, backDelay:1500, strings: ['Game','Backend'] })
  })

  return <div className="introduction" id="introduction">
    <div className="left">
      <div className="imgContainer">
        <img src="assets/Jonathan_Img_auto_x2.jpg" alt="avatar"></img>
      </div>
    </div>
    <div className="right">
      <div className="circle">
      <div className="wrapper">
          <h2>Hi There, I am</h2>
          <h1>Jonathan Gonzalez</h1>
          <h3><span ref={textRef}></span> Developer</h3>
        </div>
        <a href="#portfolio">
          <img src="/assets/down.png" alt="down"></img>
        </a>
      </div>        
    </div>
  </div>;
}
